import React, { useState } from "react";
import { Polyline } from "react-leaflet";
import CustomMarker from "./CustomMarker";
import  polyUtil  from "polyline-encoded";
import { navigateToDetail } from "../Utils/utils";

export const Routing = (props) => {
  const { route, redirectRoute, isOverview, currentZoom } = props

  const [pathOptions, setPathOptions] = useState({color: `${route.routeColor}`})
  
  const decoder = (route) => {
    const decoded = polyUtil.decode(route, 5);
    return decoded;
  }

  const handleMouseOver = () => {
    setPathOptions({color: `${route.routeColor}`, weight: 6})
  }

  const handleMouseOut = () => {
    setPathOptions({color: `${route.routeColor}`, weight: 3})
  }

  const polyline = 
    currentZoom > 11 ? (
      <Polyline
        key={route.id}
        positions={decoder(route.routing)}
        pathOptions={pathOptions}
        eventHandlers={{
          click: (e) => {
            navigateToDetail(route.id, window, redirectRoute);
          },
          mouseover: handleMouseOver,
          mouseout: handleMouseOut,
        }}
      />
    ) : null;

  return(
    <>
      <CustomMarker
        id={route.id}
        position={route.position}
        source={route.source}
        redirectRoute={redirectRoute}
        name={route.name}
        currentZoom={currentZoom}
        isOverview={isOverview}
      />
      {polyline}
    </>
    
  );
}

export default Routing;